import { useState } from "react";
import { BiCaretDown, BiCheck, BiSearch } from "react-icons/bi";
import { MdCancel } from "react-icons/md";

const DropDown = ({
  toggle,
  sortBy,
  onSortByChange,
  orderBy,
  onOrderByChange,
}) => {
  if (!toggle) {
    return null;
  }
  return (
    <div
      className="origin-top-right absolute right-0 mt-2 w-56
      rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5"
    >
      <div
        className="py-1"
        role="menu"
        aria-orientation="vertical"
        aria-labelledby="options-menu"
      >
        <div
          onClick={() => onSortByChange("name")}
          className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 flex justify-between cursor-pointer"
          role="menuitem"
        >
          Name {sortBy === "name" && <BiCheck />}
        </div>
        <div
          onClick={() => onSortByChange("department")}
          className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 flex justify-between cursor-pointer"
          role="menuitem"
        >
          Department Name {sortBy === "department" && <BiCheck />}
        </div>
        <div
          onClick={() => onSortByChange("course")}
          className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 flex justify-between cursor-pointer"
          role="menuitem"
        >
          Course {sortBy === "course" && <BiCheck />}
        </div>
        <div
          onClick={() => onOrderByChange("date")}
          className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 flex justify-between cursor-pointer border-gray-1 border-t-2"
          role="menuitem"
        >
          Date {orderBy === "date" && <BiCheck />}
        </div>
        <div
          onClick={() => onOrderByChange("time")}
          className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 flex justify-between cursor-pointer"
          role="menuitem"
        >
          Time {orderBy === "time" && <BiCheck />}
        </div>
      </div>
    </div>
  );
};

const SearchAppointment = ({
  query,
  onQueryChange,
  sortBy,
  onSortByChange,
  orderBy,
  onOrderByChange,
}) => {
  const [toggleSort, setToggleSort] = useState(false);
  return (
    <div className="py-5">
      <div className="mt-1 relative rounded-md shadow-sm">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <BiSearch />
          <label htmlFor="query" className="sr-only" />
        </div>
        <input
          type="text"
          name="query"
          id="query"
          value={query}
          onChange={(e) => {
            onQueryChange(e.target.value);
          }}
          className="pl-8 w-full h-10 rounded-md focus:ring-indigo-500 focus:border-indigo-500 block sm:text-sm border-gray-300"
          placeholder="Search Appointment by name, department, course, date, time"
        />
        <div className="absolute inset-y-0 right-0 flex items-center rounded-md">
          <div>
            <button
              type="button"
              onClick={() => setToggleSort(!toggleSort)}
              className="justify-center px-4 py-2 bg-blue-400 border-2 border-blue-400 text-sm text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 flex items-center rounded-md"
              id="options-menu"
              aria-haspopup="true"
              aria-expanded="true"
            >
              <span className="text-sm">Sort by</span>
              {toggleSort ? (
                <MdCancel className="ml-2" />
              ) : (
                <BiCaretDown className="ml-2" />
              )}
            </button>
            <DropDown
              toggle={toggleSort}
              sortBy={sortBy}
              onSortByChange={(mySort) => onSortByChange(mySort)}
              orderBy={orderBy}
              onOrderByChange={(myOrder) => onOrderByChange(myOrder)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchAppointment;
